module.exports = __webpack_public_path__ + "img/chat_emoticon_tipos_10.png?6917fb11ef754575a9c2c32798228916";